{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0, 1, 2, 3, 4, 5]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cube",
			"scale": [0.48486220836639404, 0.5177609324455261, 0.5177609324455261],
			"translation": [0, 1.0447887182235718, -0.12724626064300537]
		},
		{
			"mesh": 1,
			"name": "Cube.001",
			"rotation": [0, 1, 0, 0],
			"scale": [0.09075260162353516, 0.5177609920501709, 0.04698815569281578],
			"translation": [0, 0.3742903470993042, 0.19686338305473328]
		},
		{
			"mesh": 2,
			"name": "Cube.002",
			"rotation": [0, 1, 0, 0],
			"scale": [0.09075260162353516, 0.5177609920501709, 0.04698815569281578],
			"translation": [0, 0.3742903470993042, -0.47724825143814087]
		},
		{
			"mesh": 3,
			"name": "Cube.003",
			"scale": [0.6509976387023926, 0.5177609324455261, 0.6951689124107361],
			"translation": [0, 1.929465413093567, -0.12724626064300537]
		},
		{
			"mesh": 4,
			"name": "Cube.004",
			"rotation": [0, 0.8310897350311279, 0.5561383962631226, 0],
			"scale": [0.09075260162353516, 0.19860391318798065, 0.043104030191898346],
			"translation": [0, 0.9373260736465454, -1.013484239578247]
		},
		{
			"mesh": 5,
			"name": "Cube.005",
			"rotation": [-0.5559735894203186, -0.02022550068795681, -0.013534251600503922, 0.8308436274528503],
			"scale": [0.09075259417295456, 0.19860391318798065, 0.043104030191898346],
			"translation": [0, 0.9373260736465454, 0.7358969449996948]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.0341222882270813, 1, 0.9040495753288269, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.001",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.03290729597210884, 1, 0.8133843541145325, 1],
				"metallicFactor": 0.007874015718698502,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.002",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.02736716903746128, 1, 0.9040212631225586, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.003",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.012989350594580173, 1, 0.770313560962677, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.004",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.05947880446910858, 1, 0.8808546662330627, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.005",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.03728421404957771, 1, 0.8580524921417236, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Cube",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				}
			]
		},
		{
			"name": "Cube.001",
			"primitives": [
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 3,
					"material": 1
				}
			]
		},
		{
			"name": "Cube.002",
			"primitives": [
				{
					"attributes": {
						"POSITION": 7,
						"NORMAL": 8,
						"TEXCOORD_0": 9
					},
					"indices": 3,
					"material": 2
				}
			]
		},
		{
			"name": "Cube.003",
			"primitives": [
				{
					"attributes": {
						"POSITION": 10,
						"NORMAL": 11,
						"TEXCOORD_0": 12
					},
					"indices": 3,
					"material": 3
				}
			]
		},
		{
			"name": "Cube.004",
			"primitives": [
				{
					"attributes": {
						"POSITION": 13,
						"NORMAL": 14,
						"TEXCOORD_0": 15
					},
					"indices": 3,
					"material": 4
				}
			]
		},
		{
			"name": "Cube.005",
			"primitives": [
				{
					"attributes": {
						"POSITION": 16,
						"NORMAL": 17,
						"TEXCOORD_0": 18
					},
					"indices": 3,
					"material": 5
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 24,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 36,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 24,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5126,
			"count": 24,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 24,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 11,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 12,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 13,
			"componentType": 5126,
			"count": 24,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 14,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 15,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		},
		{
			"bufferView": 16,
			"componentType": 5126,
			"count": 24,
			"max": [1, 1, 1],
			"min": [-1, -1, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 17,
			"componentType": 5126,
			"count": 24,
			"type": "VEC3"
		},
		{
			"bufferView": 18,
			"componentType": 5126,
			"count": 24,
			"type": "VEC2"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 288,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 576,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 72,
			"byteOffset": 768,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 840,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 1128,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 1416,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 1608,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 1896,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 2184,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 2376,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 2664,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 2952,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 3144,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 3432,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 3720,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 3912,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 288,
			"byteOffset": 4200,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 192,
			"byteOffset": 4488,
			"target": 34962
		}
	],
	"buffers": [
		{
			"byteLength": 4680,
			"uri": "sample%20player.bin"
		}
	]
}
